import React from 'react';
import { ReactComponent as Icon } from 'assets/icons/brand-status.svg';
import { Input } from '@cokitchen/cokitchen-components';
import './style.scss';

type Props = {
  comment: string;
  setComment: (comment: string) => void;
  className?: string;
  disabled?: boolean;
  setSelectedShopStatus?: (prev: string[]) => void;
  selectedShopStatus: string[];
};

const brandStatus = ['new', 'top', 'delivery', 'inventory', 'coming_soon'];

const ShopStatus = ({
  comment,
  setComment,
  className,
  disabled,
  setSelectedShopStatus,
  selectedShopStatus
}: Props) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;

    if (checked) {
      setSelectedShopStatus?.([...selectedShopStatus, value]);
    } else {
      setSelectedShopStatus?.(selectedShopStatus.filter((keyword) => keyword !== value));
    }
  };
  const hasComingSoon = selectedShopStatus.includes('coming_soon');
  return (
    <div className={`w-full p-[20px] bg-[#F9F6F6] rounded-md ${className}`}>
      <div className='flex gap-2 mb-8'>
        <Icon className='text-[#1D0105]' />
        <p className='text-sm text-[#1D0105] font-medium'>Select the status of this shop</p>
      </div>
      <div className='flex gap-10 flex-wrap'>
        {brandStatus.map((status) => (
          <div key={status} className='flex gap-[8px] items-center'>
            <Input
              type='checkbox'
              name={status}
              checked={selectedShopStatus.includes(status)}
              onChange={(e) => handleCheckboxChange(e)}
              label={status.replaceAll('_', ' ')}
              value={status}
              className='capitalize'
              disabled={disabled}
            />
          </div>
        ))}
      </div>

      {hasComingSoon && (
        <div className='w-full mt-6'>
          <Input
            type='text'
            placeholder='Enter coming soon  text'
            className='w-full mt-4'
            inputClass='px-[20px] py-[14px]'
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
};

export default ShopStatus;
